import {
  AWSFileUploadAPI,
  AWSRequestAPI,
  contraAPI,
  primusAPI,
  TradeMutualIpoAPI,
  spanCalculationAPI,
  primusLoginAPI,
  UploadFormDataAPI,
  KYCAPI,
  contraAPINew,
  // MarginAPI,
  FreezeAPI,
} from "./request";

function searchInstrument(query) {
  return contraAPI({
    endpoint: `/api/v1/search`,
    method: "GET",
    params: { key: (query || "").trim() },
  });
}

function fetchScripInfo(exchange, token, execution) {
  /* Here we are checking token is NaN or not because during modification of SPREAD order execution is spread
    but token is not like "23834-343394" but is like "23834" */

  if (execution !== "SPREAD" || (execution === "SPREAD" && !isNaN(token))) {
    return contraAPI({
      endpoint: `/api/v1/contract/${exchange}`,
      method: "GET",
      params: {
        info: "scrip",
        token,
      },
    });
  } else {
    return contraAPI({
      endpoint: `/api/v1/contract/${exchange}`,
      method: "GET",
      params: {
        info: "scrip",
        token,
        execution: "spread",
      },
    });
  }
}

function fetchUserProfile() {
  return primusAPI({
    endpoint: `/api/v1/user/profile?client_id=${localStorage.getItem(
      "login_id"
    )}`,
    method: "GET",
  });
}

function fetchUserSettings() {
  return primusAPI({
    endpoint: `/api/v1/management/user/settings?client_id=${localStorage.getItem(
      "login_id"
    )}`,
    method: "GET",
  });
}

function updateUserSettings(payload) {
  return primusAPI({
    endpoint: "/api/v1/management/user/settings",
    method: "POST",
    data: { ...payload, client_id: localStorage.getItem("login_id") },
  });
}

function saveExistingMarketwatch(payload) {
  return primusAPI({
    endpoint: `/api/v1/marketwatches/save/${payload.mw_id}`,
    method: "PUT",
    data: { ...payload },
  });
}

// function login(loginId, password) {
//   return primusLoginAPI({
//     endpoint: "/api/v1/user/login",
//     method: "POST",
//     headers: {},
//     data: {
//       login_id: loginId,
//       password,
//       device: "WEB",
//     },
//   });
// }
function login(loginId, password) {
  return primusLoginAPI({
    endpoint: "/api/v4/user/login",
    method: "POST",
    headers: {},
    data: {
      channel_id: loginId,
      channel_secret: password,
      // device: "WEB",
    },

  });
}


function loginV3(payload) {
 
  return primusLoginAPI({
    endpoint: "/api/v3/user/login",
    method: "POST",
    headers: {
      "x-device-type": "web",
      // "x-device-id": 1234
    },
    data: {
      channel_id: payload.loginId,
      channel_secret: payload.isLoginWithOTP ? "" : payload.password,
      // device: "WEB",
    },
  });
}

function ForgotPasswordSentOTP(payload) {
  return primusLoginAPI({
    endpoint: "/api/v4/user/password/forgot/otp",
    method: "POST",
    data: payload,
  });
}

function unblockUser(login_id, email, pan) {
  return primusAPI({
    endpoint: "/api/v1/user/unblock_user",
    method: "POST",
    headers: {},
    data: {
      login_id,
      email,
      pan,
    },
  });
}

function tlUnblockUser(login_id, pan) {
  return primusAPI({
    endpoint: "/api/v1/management/user/unblock_user",
    method: "POST",
    headers: {},
    data: {
      login_id,
      pan,
    },
  });
}

function fetchAvailableTwofaOptions() {
  return new Promise((resolve, reject) => {
    resolve({
      status: "success",
      message: "",
      data: [
        {
          label: "Questions 2FA",
          value: "Questions",
        },
        {
          label: "Email OTP",
          value: "OTP",
        },
        {
          label: "Pin",
          value: "PIN",
        },
      ],
    });
  });
}

function fetchQuestionsforTwofa() {
  return primusAPI({
    endpoint: "/api/v1/get_questions",
    method: "POST",
  });
}

function updateTwofa(twofaType, twofa, loginId, authToken) {
  const data = {
    login_id: (
      loginId || window.localStorage.getItem("login_id")
    ).toUpperCase(),
    twofa_type: twofaType,
  };
  switch (twofaType) {
    case "PIN":
      // if (typeof twofa !== "number") {
      //
      //   return;
      // }
      data.pin = twofa;
      break;
    case "Questions":
      if (!Array.isArray(twofa)) {
        return;
      }
      data.twofa = twofa;
      break;
    default:
      break;
  }
  return primusAPI({
    endpoint: "/api/v1/choose_twofa",
    method: "POST",
    headers: {
      "x-authorization-token": authToken || localStorage.getItem("token"),
      "x-device-type": "web",
    },
    data,
  });
}

//  API call for resetting 2FA for Tradelab backend
function reset2FA(payload) {
  return primusAPI({
    endpoint: `/api/v1/user/force_reset_twofa`,
    method: "PUT",
    params: payload,
  });
}

//  API call for resetting 2FA for TR backend
function reset2FA_TR(login_id, email, pan) {
  return primusAPI({
    endpoint: `/api/v1/user/reset_twofa`,
    method: "POST",
    params: {
      login_id,
      email,
      pan,
    },
  });
}

function updateTPin(TPin) {
  return primusAPI({
    endpoint: `/api/v1/edis/update_tpin`,
    method: "PUT",
    data: {
      client_id: localStorage.getItem("login_id"),
      tpin: TPin,
    },
  });
}

function getForgotPasswordTradelab(loginId) {
  return primusAPI({
    endpoint: "/api/v1/user/password/forgot",
    method: "GET",
    params: {
      login_id: loginId,
    },
  });
}

function setForgotPasswordTR(payload) {
  return primusAPI({
    endpoint: "/api/v1/user/password/forgotpw",
    method: "POST",
    data: payload,
  });
}

function setForgotPasswordTradelab(payload) {
  return primusAPI({
    endpoint: "/api/v1/user/password/forgot",
    method: "POST",
    data: payload,
  });
}

function resetPassword(payload) {
  return primusAPI({
    endpoint: "/api/v1/user/password/reset",
    method: "POST",
    data: payload,
  });
}
function authoriseHoldings(payload) {
  return primusAPI({
    endpoint: " /api/v1/edis/instrument_details",
    method: "POST",
    data: payload,
  });
}

function changePassword(old_password, new_password) {
  return primusAPI({
    endpoint: "/api/v1/user/password",
    method: "PUT",
    data: {
      old_password,
      new_password,
    },
  });
}


function twoFA(loginId, objAnswers, twoFAToken, twoFAType) {
  return primusAPI({
    endpoint: "/api/v1/user/twofa",
    method: "POST",
    data: {
      login_id: loginId,
      twofa: Object.entries(objAnswers).map(([question_id, answer]) => ({
        question_id,
        answer,
      })),
      twofa_token: twoFAToken,
      type: twoFAType,
    },
    headers: {},
    bypassUnauthorizedCheck: true,
  });
}

function twoFAV3(loginId, objAnswers, twoFAToken, twoFAType) {
  return primusAPI({
    endpoint: "/api/v3/user/twofa",
    method: "POST",
    data: {
      login_id: loginId,
      twofa: Object.entries(objAnswers).map(([question_id, answer]) => ({
        question_id: Number(question_id),
        answer: answer
      })),
      twofa_token: twoFAToken,
      type: twoFAType,
      device_type: "web"
    },
    headers: {
      "x-device-type": "web"
    },
    bypassUnauthorizedCheck: true,
  });
}

function setupTOTP(loginId, authToken) {
  return primusAPI({
    endpoint: "/api/v3/setup_totp",
    method: "POST",
    data: {
      client_id: loginId
    },
    headers: {
      "x-authorization-token": authToken
    }
  })
}

function chooseTOTP(userId, totp, authToken) {
  return primusAPI({
    endpoint: "/api/v3/choose_twofa",
    method: "POST",
    data: {
      login_id: userId,
      twofa_type: "TOTP",
      totp: totp
    },
    headers: {
      "x-authorization-token": localStorage.getItem("token")
    }
  })
}

function forgotTOTP(loginId, pan) {
  return primusAPI({
    endpoint: '/api/v3/user/forgot_totp',
    method: "POST",
    data: {
      login_id: loginId,
      pan: pan
    }
  })
}

function convertPosition(payload) {
  return primusAPI({
    endpoint: "/api/v1/position/convert",
    method: "PUT",
    data: payload,
  });
}

function fetchMarketWatches() {
  return primusAPI({
    endpoint: "/api/v1/marketwatches",
    method: "GET",
  });
}

function addNewMarketwatch(name) {
  return primusAPI({
    endpoint: `/api/v1/marketwatches`,
    method: "POST",
    data: {
      name,
    },
  });
}

function addMarketWatchInstrument(payload) {
  return primusAPI({
    endpoint: `/api/v1/marketwatches`,
    query: payload.mw_id,
    method: "PUT",
    data: payload,
  });
}

function feedback(payload) {
  return primusAPI({
    endpoint: "/api/v1/user/feedback",
    method: "POST",
    data: payload,
  });
}
function addFunds(payload) {
  return primusAPI({
    endpoint: "/api/v1/pg/tx/order",
    method: "POST",
    data: payload,
  });
}
 function getBankAccountOtp(payload) {
 return primusAPI({
  endpoint: "/api/v1/user/tx/bank/otp",
  method: "POST",
  data: payload,
 })
 
}

function addBankAccount(payload) {
  return primusAPI({
    endpoint: "/api/v1/user/tx/bank",
    method: "POST",
    data: payload,
  });
}


function deleteMarketWatchInstrument({
  marketWatchId,
  exchange,
  token,
  symbolName,
  execution,
}) {
  return primusAPI({
    endpoint: `/api/v1/marketwatches`,
    method: "DELETE",
    query: marketWatchId,
    params: {
      exchange,
      token,
      trading_symbol: symbolName,
      execution,
    },
  });
}

function fetchPendingOrders() {
  return primusAPI({
    endpoint: "/api/v1/orders",
    method: "GET",
    params: {
      type: "pending",
      client_id: localStorage.getItem("login_id"),
    },
  });
}

function fetchCompletedOrders() {
  return primusAPI({
    endpoint: "/api/v1/orders",
    method: "GET",
    params: {
      type: "completed",
      client_id: localStorage.getItem("login_id"),
    },
  });
}

function fetchTrades() {
  return primusAPI({
    endpoint: "/api/v1/trades",
    method: "GET",
    params: {
      client_id: localStorage.getItem("login_id"),
    },
  });
}

function fetchPositions(positionType) {
  return primusAPI({
    endpoint: "/api/v1/positions",
    method: "GET",
    params: {
      client_id: localStorage.getItem("login_id"),
      type: positionType,
    },
  });
}

function fetchOrderHistory(orderId) {
  return primusAPI({
    endpoint: `/api/v1/order/${orderId}/history`,
    method: "GET",
    params: {
      client_id: localStorage.getItem("login_id"),
    },
  });
}

function fetchHoldings(productCode) {
  return primusAPI({
    endpoint: "/api/v1/holdings",
    method: "GET",
    params: {
      product_code: productCode || "",
      client_id: localStorage.getItem("login_id"),
    },
  });
}

function fetchAlerts() {
  return primusAPI({
    endpoint: "/api/v1/alerts",
    method: "GET",
  });
}

function fetchScreeners(endpoint) {
  return primusAPI({
    endpoint,
    method: "GET",
  });
}

function logout() {
  return primusAPI({
    endpoint: "/api/v1/user/logout",
    method: "DELETE",
  });
}

function postAlertModal(alertsData) {
  return primusAPI({
    endpoint: "/api/v1/alerts",
    method: "POST",
    data: alertsData,
  });
}

function modifyAlert(alert_id, payload) {
  return primusAPI({
    endpoint: `/api/v1/alerts/${alert_id}`,
    method: "PUT",
    data: payload,
  });
}

function fetchFundsTypes() {
  return primusAPI({
    endpoint: `/api/v1/funds/types`,
    method: "GET",
    params: {
      client_id: window.localStorage.getItem("login_id"),
    },
  });
}

function fetchFundsView(fundType) {
  return primusAPI({
    endpoint: `/api/v1/funds/view`,
    method: "GET",
    params: {
      client_id: window.localStorage.getItem("login_id"),
      type: `${fundType}`,
    },
  });
}

function fetchFundsViewV2(fundType) {
  return primusAPI({
    endpoint: `/api/v1/user/funds/margins`,
    method: "GET",
    params: {
      client_id: window.localStorage.getItem("login_id"),
    },
  });
}

function placeRegularOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders",
    method: "POST",
    data: payload,
  });
}

function modifyRegularOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders",
    method: "PUT",
    data: payload,
  });
}

function getBrokerageData(payload) {
  return spanCalculationAPI({
    endpoint: "/api/v1/brokerage/calculate",
    method: "GET",
    params: payload
  })
}


function placeBracketOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/bracket",
    method: "POST",
    data: payload,
  });
}

function placeBracketOrderTRADELAB(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/kart",
    method: "POST",
    data: payload,
  });
}

function placeCOOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/bracket",
    method: "POST",
    data: payload,
  });
}

function placeCoverOrderTRADELAB(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/kart",
    method: "POST",
    data: payload,
  });
}

function modifyBracketOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/bracket",
    method: "PUT",
    data: payload,
  });
}

function modifyBracketOrderTRADELAB(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/kart",
    method: "PUT",
    data: payload,
  });
}

function cancelBracketOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/bracket",
    method: "DELETE",
    data: payload,
  });
}

function cancelBracketOrderTRADELAB(payload) {
  return primusAPI({
    endpoint: `/api/v1/orders/kart/${payload.oms_order_id}`,
    method: "DELETE",
    data: payload,
  });
}

function exitCoverOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/cover",
    method: "DELETE",
    data: payload,
  });
}

function exitCoverOrderTRADELAB(payload) {
  return primusAPI({
    endpoint: `/api/v1/orders/kart/${payload.oms_order_id}`,
    method: "DELETE",
    data: payload,
  });
}

function modifyCoverOrderTRADELAB(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/kart",
    method: "PUT",
    data: payload,
  });
}

function placeOCOOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/kart",
    method: "POST",
    data: payload,
  });
}

function modifyOCOOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/kart",
    method: "PUT",
    data: payload,
  });
}

function cancelOCOOrder(payload) {
  return primusAPI({
    endpoint: `/api/v1/orders/kart/:${payload.oms_order_id}`,
    method: "DELETE",
    data: payload,
  });
}

function placeSpreadOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/kart",
    method: "POST",
    data: payload,
  });
}

function modifySpreadOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/orders/kart",
    method: "PUT",
    data: payload,
  });
}

function cancelSpreadOrderTRADELAB(payload) {
  return primusAPI({
    endpoint: `/api/v1/orders/kart/${payload.oms_order_id}`,
    method: "DELETE",
    data: payload,
  });
}

function fetchChartData(payload) {
  return primusAPI({
    endpoint: `/api/v1/charts`,
    method: `GET`,
    params: payload,
  });
}

function deleteAlert(alert_id) {
  return primusAPI({
    endpoint: `/api/v1/alerts/${alert_id}`,
    method: "DELETE",
  });
}

function pausePlayAlert(alert_id, payload) {
  return primusAPI({
    endpoint: `/api/v1/alerts/${alert_id}`,
    method: "PUT",
    data: payload,
  });
}

function deletePendingOrder(oms_order_id, execution_type) {
  return primusAPI({
    endpoint: `/api/v1/orders/${oms_order_id}`,
    method: "DELETE",
    params: {
      client_id: window.localStorage.getItem("login_id"),
      execution_type,
    },
  });
}

function getPinnedInstruments() {
  return primusAPI({
    endpoint: `/api/v1/dashboard/pins`,
    method: `GET`,
  });
}

function setPinnedInstruments(payload) {
  return primusAPI({
    endpoint: `/api/v1/dashboard/pins`,
    method: `PUT`,
    data: payload,
  });
}

function fetchAutorizedApps() {
  return primusAPI({
    endpoint: "/api/v1/oauth/apps",
    method: "GET",
    params: {
      client_id: localStorage.getItem("login_id"),
    },
  });
}

function getPaymentLink({ direction }) {
  return primusAPI({
    endpoint: `/api/v1/payment/${direction}`,
    method: "GET",
  });
}

function postAccountBackofficePayout(payload) {
  //<--------- POST API for fetching acc. detailes
  return primusAPI({
    endpoint: "/api/v1/account/backoffice/payout",
    method: "POST",
    data: payload,
  });
}

function getAccountDetailsBackofficePayout({ financial_year, client_code }) {
  //<--------- GET API for fetching acc. detailes
  return primusAPI({
    endpoint: `/api/v1/account/details?financial_year=${financial_year}&client_code=${client_code}`,
    method: "GET",
  });
}

function getCoOrderTriggerRange({ exchange, token, transaction_type }) {
  return primusAPI({
    endpoint: "/api/v1/cotriggerrange",
    method: "GET",
    params: { exchange, token, transaction_type },
  });
}

function pledgeInstruments(payload) {
  return primusAPI({
    endpoint: "/api/v1/pledge",
    method: "POST",
    data: payload,
  });
}

function createBasketOrderDetails(payload) {
  return primusAPI({
    endpoint: `/api/v1/basket`,
    method: `POST`,
    data: payload,
  });
}

function fetchBasketOrderDetails() {
  return primusAPI({
    endpoint: `/api/v1/basket`,
    method: `GET`,
    params: {
      login_id: localStorage.getItem("login_id"),
    },
  });
}

function getSingleBasketId({ basket_id }) {
  // fetch single basket
  return primusAPI({
    endpoint: `/api/v1/get_basket?basket_id=${basket_id}`,
    method: `GET`,
  });
}

function updateBasketExecutionState(payload) {
  // update execution state after reset
  return primusAPI({
    endpoint: `/api/v1/update_basket_execution_state`,
    method: `POST`,
    data: payload,
  });
}

function deleteBasketOrderDetails(payload) {
  return primusAPI({
    endpoint: `/api/v1/basket`,
    method: `DELETE`,
    data: payload,
  });
}
function addBasketInstrumentDetails(payload) {
  return primusAPI({
    endpoint: `/api/v1/basket/order`,
    method: `POST`,
    data: payload,
  });
}

function updateBasketInstrumentDetails(payload) {
  return primusAPI({
    endpoint: `/api/v1/basket/order`,
    method: `PUT`,
    data: payload,
  });
}

function removeBasketInstrumentDetails(payload) {
  return primusAPI({
    endpoint: `/api/v1/basket/order`,
    method: `DELETE`,
    data: payload,
  });
}

function renameBasketName(payload) {
  return primusAPI({
    endpoint: `/api/v1/basket`,
    method: `PUT`,
    data: payload,
  });
}

function executeBasket(payload) {
  return primusAPI({
    endpoint: `/api/v1/orders/kart`,
    method: `POST`,
    data: payload,
  });
}
function getAllIpo() {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/tradeipo/get-all-ipo",
    method: "POST",
  });
}

function findMissingDetails() {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/tradeipo/find-missing-details",
    method: "POST",
    data: {
      client_id: localStorage.getItem("login_id"),
    },
  });
}

function updateMissingDetails(missingDetails) {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/tradeipo/update-missing-details",
    method: "POST",
    data: missingDetails,
  });
}

function placeOrder(placeOrderQuery) {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/tradeipo/place-order",
    method: "POST",
    data: placeOrderQuery,
  });
}

function modifyOrder(modifyOrderQuery) {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/tradeipo/modify-orders",
    method: "PUT",
    data: modifyOrderQuery,
  });
}
function cancelOrder(cancelOrderQuery) {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/tradeipo/cancel-order",
    method: "POST",
    data: cancelOrderQuery,
  });
}
function cancelAMOOrder(cancelAMOOrderQuery) {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/tradeipo/amo-cancel",
    method: "POST",
    data: cancelAMOOrderQuery,
  });
}
function fetchOrder() {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/tradeipo/fetch-order",
    method: "POST",
    data: {
      client_id: localStorage.getItem("login_id"),
    },
  });
}

// ofs

function fetchAllOfs() {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/ofs/activeSecurities",
    method: "GET",
  });
}
function PlaceOfsOrder(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/ofs/order",
    method: "POST",
    data: payload,
  });
}
function ModifyOfsOrder(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/ofs/order",
    method: "PUT",
    data: payload,
  });
}
function CancelOfsOrder(order_id) {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/ofs/order",
    method: "DEL",
    params: {
      order_id: order_id,
    },
  });
}
function OfsOrdersByClient(payload) {

  return TradeMutualIpoAPI({
    endpoint: `/api/v1/ofs/order`,
    method: `GET`,
    data: { payload },
    // {
    //   client_id: payload, //localStorage.getItem("login_id"),
    // },
  });
}
/*basan-beta.tradelab.in/api/v1/optionchain/NFO?token=3045&num=3&price=332
  Optionchain deployed on basan-beta*/
function fetchOptionChain(payload) {
  return contraAPI({
    endpoint: `/api/v1/optionchain/${payload.exchange}`,
    method: "GET",
    params: {
      num: payload.num,
      token: payload.token,
      price: payload.price,

    },
  });
}

function signUp(payload) {
  return primusAPI({
    endpoint: "api/v1/user/signup",
    method: "GET",
    data: payload,
  });
}

function payoutTransactions(payload) {

  return primusAPI({
    endpoint: `/api/v1/pg/tx/transactions?client_id=${payload.client_id}`,
    method: "GET",
  });
}

function GetFunds() {
  return primusAPI({
    endpoint: "/api/v1/funds/transactions",
    method: "GET",
    params: {
      client_id: localStorage.getItem("login_id"),
    },
  });
}

function fetchBucketDataS3() {
  const fileName = localStorage.getItem("login_id") + ".png";
  return AWSRequestAPI({
    endpoint: "/api/v1/upload/s3Url",
    method: "POST",
    data: {
      file_name: `/profiles/${fileName}`,
    },
  });
}

function uploadProfilePictureS3(s3BucketUrl, imgUrl) {
  const contentType = imgUrl.type;
  const options = {
    headers: {
      "Content-Type": contentType,
    },
  };
  return AWSFileUploadAPI({
    endpoint: s3BucketUrl,
    method: "PUT",
    data: imgUrl,
    options,
  });
}

function updateProfilePicturePrimus(s3_key) {
  // const fileName = localStorage.getItem("login_id") + ".png";
  const client_id = localStorage.getItem("login_id");
  return primusAPI({
    endpoint: "/api/v1/management/user/profile_url",
    method: "PUT",
    data: {
      client_id,
      url: s3_key, //fileName
    },
  });
}

function getLtp(payload) {
  let url;
  if (payload.exchange === "NSE") {
    url = `/api/v1/marketdata/NSE/Capital?token=${payload.token}&key=last_trade_price`;
  } else if (payload.exchange === "BSE") {
    url = `/api/v1/marketdata/BSE/Capital?token=${payload.token}&key=last_trade_price`;
  } else if (payload.exchange === "NFO") {
    url = `/api/v1/marketdata/NSE/FutOpt?token=${payload.token}&key=last_trade_price`;
  } else if (payload.exchange === "CDS") {
    url = `/api/v1/marketdata/NSE/Currency?token=${payload.token}&key=last_trade_price`;
  } else if (payload.exchange === "MCX") {
    url = `/api/v1/marketdata/MCX/FutOpt?token=${payload.token}&key=last_trade_price`;
  }
  return primusAPI({
    endpoint: url,
    method: "GET",
    data: payload,
  });
}

function fetchFinStmtBackofficeIntegrated(payload) {
  return primusAPI({
    endpoint: "/api/v1/account/statement",
    method: "GET",
    params: payload,
  });
}

function fetchDigitalContractBackofficeIntegrated(payload) {
  return primusAPI({
    endpoint: "/api/v1/account/contract",
    method: "GET",
    params: payload,
  });
}

function fetchAdminMessages() {
  return primusAPI({
    endpoint: "/api/v1/latest/updates",
    method: "GET",
    params: {
      type: "admin_message",
      client_id: localStorage.getItem("login_id"),
    },
  });
}

// function fetchTotalMargin(xe_uuid,product_type) {
//   return MarginAPI({
//     endpoint: `/api/v1/oms/margins`,
//     method: "GET",
//     params: {
//       client_id: localStorage.getItem("login_id"),
//       xe_uuid:xe_uuid,
//       product_type:product_type
//     },
//   });
// }
function fetchMarginCalculatorV1(payload) {
  return spanCalculationAPI({
    endpoint: `/api/v1/calculator`,
    method: "POST",
    data: payload,
  });
}

function fetchMarginCalculatorV2(payload) {
  return spanCalculationAPI({
    endpoint: `/api/v1/calc`,
    method: "POST",
    data: payload,
  });
}

function ePledgeHoldings(payload) {
  return primusAPI({
    endpoint: "/api/v1/epledge",
    method: "POST",
    data: payload,
  });
}

function fetchTrasferStatusLink() {
  return primusAPI({
    endpoint: "/api/v1/transferstatus",
    method: "GET",
  });
}

function placeGTTOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/event/gtt",
    method: "POST",
    data: payload,
  });
}

function fetchGTTOrders() {
  const client_id = localStorage.getItem("login_id");
  return primusAPI({
    endpoint: `/api/v1/event/gtt/${client_id}`,
    method: "GET",
  });
}

function cancelGTTOrder(id) {
  const client_id = localStorage.getItem("login_id");
  return primusAPI({
    endpoint: `/api/v1/event/gtt/${client_id}/${id}`,
    method: "DELETE",
  });
}

function modifyGTTOrder(payload) {
  return primusAPI({
    endpoint: "/api/v1/event/gtt",
    method: "PUT",
    data: payload,
  });
}

function revokeAuthorization(payload) {
  return primusAPI({
    endpoint: "/api/v1/edis/cdsl_revoke",
    method: "POST",
    data: payload,
  });
}

function verifyCaptchaToken(payload) {
  return primusAPI({
    endpoint: `/api/v1/user/verifycaptcha`,
    method: "PUT",
    params: {
      captcha: payload.token,
    },
  });
}

function placeSingleSIPOrder(payload) {
  return primusAPI({
    endpoint: `/api/v1/event/sip`,
    method: "POST",
    params: {
      client_id: localStorage.getItem("login_id"),
    },
    data: payload,
  });
}

function placeSIPOrder(payload) {
  return primusAPI({
    endpoint: `/api/v1/event/sip`,
    method: "POST",
    params: {
      client_id: localStorage.getItem("login_id"),
    },
    data: payload,
  });
}

function fetchSIPOrders(payload) {
  const client_id = localStorage.getItem("login_id");
  return primusAPI({
    endpoint: `/api/v1/event/sip/${client_id}`,
    method: "GET",
    data: payload,
  });
}

function cancelSIPOrder(id) {
  const client_id = localStorage.getItem("login_id");
  return primusAPI({
    endpoint: `/api/v1/event/sip/${client_id}/${id}`,
    method: "DELETE",
  });
}

function modifySIPOrder(payload) {
  return primusAPI({
    endpoint: `/api/v1/event/sip`,
    method: "PUT",
    data: payload,
  });
}

function pausePlaySIP(payload) {
  return contraAPI({
    endpoint: `/api/v1/events/sip/revocation`,
    method: "PUT",
    data: payload,
  });
}

function FetchNotifyingActions() {
  return primusAPI({
    endpoint: "/api/v1/management/user/postman/actions",
    method: "GET",
  });
}

function FetchUserPreferences() {
  return primusAPI({
    endpoint: `/api/v1/management/user/postman/preferences?client_id=${localStorage.getItem(
      "login_id"
    )}`,
    method: "GET",
  });
}

function CreateUserPreference(payload) {
  return primusAPI({
    endpoint: `/api/v1/management/user/postman/preferences`,
    method: "POST",
    data: payload,
  });
}

function UpdateUserPreference(payload) {
  return primusAPI({
    endpoint: `/api/v1/management/user/postman/preferences`,
    method: "PUT",
    data: payload,
  });
}

function setNewPasswordTR(payload) {
  return primusAPI({
    endpoint: "/api/v1/user/password/validateSetPw",
    method: "POST",
    data: payload,
  });
}

function placeSIP(payload) {
  return primusAPI({
    endpoint: "/api/v1/event/sip",
    method: "POST",
    data: payload,
  });
}

function getSipNameWithBasketID(payload) {
  return primusAPI({
    endpoint: `/api/v1/sip/basket`,
    method: "GET",
    params: {
      client_id: localStorage.getItem("login_id"),
      login_id: localStorage.getItem("login_id"),
      basket_id: payload,
    },
  });
}

function userSignUp(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/v1/user/otp/email",
    method: "POST",
    data: payload,
  });
}

function getBrokerMasters(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/master/basan",
    method: "GET",
  });
}

function verifyOTPtoUserLogin(payload) {
  return TradeMutualIpoAPI({
    endpoint: "api/v1/user/verify/email",
    method: "POST",
    data: payload,
  });
}

function KRAUserDetails(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/kra-details",
    method: "POST",
    data: payload,
  });
}

function sendOTPToMobile(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/send-otp/sms",
    method: "POST",
    data: payload,
  });
}

function verifyMobileOTP(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/verify-otp/sms",
    method: "POST",
    data: payload,
  });
}

/*function getKYCDetails(payload) {
  return primusAPI({
    endpoint: "/api/kyc/v1/kycdetails",
    method: "GET",
    params: {
      emailid: payload
    },
  })
}*/

//TODO : check port
function updateUserAddress(payload) {
  return primusAPI({
    endpoint: "/api/kyc/v1/user/address",
    method: "PUT",
    data: payload,
  });
}
//TODO : check port
function savePersonalDetails(payload) {
  return primusAPI({
    endpoint: "/api/kyc/v1/user/personal-details",
    method: "POST",
    params: payload,
  });
}

function generateDigiLockerAccessToken(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/digilocker-auth-token",
    method: "GET",
    params: payload,
  });
}

function SavePersonalDetails(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/user/personal-details",
    method: "POST",
    data: payload,
  });
}

function VerifyBankDetails(payload) {
  return KYCAPI({
    endpoint: "/api/kyc/v1/verify-bank-account",
    method: "POST",
    data: payload,
  });
}

function loginWithOTP(payload) {
  return primusAPI({
    endpoint: `/api/v1/user/login/otp`,
    method: "POST",
    data: payload,
  });
}

// function loginWithOTPV3(payload) {
//   return primusAPI({
//     endpoint: `/api/v3/user/login/otp`,
//     method: "POST",
//     data: payload,
//   });
// }

function verifyLoginOTP(payload) {
  return primusAPI({
    endpoint: `/api/v3/user/login/otp`,
    method: "PUT",
    data: payload,
  });
}

function getKYCDetails(emailId) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/kycdetails",
    method: "GET",
    params: {
      emailId:
        (localStorage.getItem("login_id") &&
          localStorage.getItem("login_id").toLowerCase()) ||
        emailId,
    },
  });
}

function readKycAPI(body) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v2/readKYC",
    method: "POST",
    params: {
      emailId:
        (localStorage.getItem("login_id") &&
          localStorage.getItem("login_id").toLowerCase())
    },
    data: body
  });
}

function uploadKycAPI(body) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/uploadKYC",
    method: "POST",
    params: {
      emailId:
        (localStorage.getItem("login_id") &&
          localStorage.getItem("login_id").toLowerCase())
    },
    data: body
  });
}

//Nominees
function fetchNominees(emailId) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/user/nominees",
    method: "GET",
    params: {
      userName: emailId,
    },
  });
}

function saveNominees(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/user/nominee",
    method: "POST",
    data: payload,
  });
}

function saveNomineesV2(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v2/user/nominee",
    method: "POST",
    data: payload,
  });
}

function updateNomineeShares(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/user/nominee",
    method: "PATCH",
    data: payload,
  });
}

function deleteNominee(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/user/nominee",
    method: "DELETE",
    data: payload,
  });
}

function updateDigioStatus(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/kid-details",
    method: "POST",
    data: payload,
  });
}
function withdrawFunds(payload) {
  return primusAPI({
    endpoint: "/api/v1/pg/tx/withdrawal",
    method: "POST",
    data: payload,
  });
}
function updateEsignDownload(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/esign-download",
    method: "POST",
    data: payload,
  });
}
function getAllBanks(payload) {
  return UploadFormDataAPI({
    endpoint: "/api/bankservice/v1/banks",
    method: "GET",
    params: payload,
  });
}
function getBankDetailsByIFSC(payload) {
  return UploadFormDataAPI({
    endpoint: "/api/bankservice/bank_details",
    method: "GET",
    params: payload,
  });
}
function getAllBranchesOfABank(payload) {
  return UploadFormDataAPI({
    endpoint: "/api/bankservice/v1/bank_branches",
    method: "GET",
    params: payload,
  });
}
function getBankDetailsByBankNameAndBranch(payload) {
  return UploadFormDataAPI({
    endpoint: "/api/bankservice/v1/search_bank_branch",
    method: "GET",
    params: payload,
  });
}

function getDigilockerEsignReqId(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/digilocker-esign-request-id",
    method: "GET",
    params: payload,
  });
}

function getSubscriptionPlans(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/subscription-plans",
    method: "GET",
    params: payload,
  });
}

function updateSubscriptionPlans(payload) {
  return TradeMutualIpoAPI({
    endpoint: `/api/kyc/v1/user/subscription-plan`,
    method: "PUT",
    data: payload,
  });
}

function getDigilockerAuthToken(emailId) {
  return TradeMutualIpoAPI({
    endpoint: `/api/kyc/v1/digilocker-auth-token`,
    method: "GET",
    params: {
      email: emailId,
    },
  });
}

function getKYCDetailsEnums() {
  return TradeMutualIpoAPI({
    endpoint: "/api/us-stocks/v1/onboarding-details-enums",
    method: "GET",
  });
}

function saveTradingPreference(payload) {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/derivatives",
    method: "POST",
    data: payload,
  });
}

function getUserExperinceDetails() {
  return TradeMutualIpoAPI({
    endpoint: "/api/kyc/v1/experience",
    method: "GET",
  });
}

function AuctionDetails(payload) {
  return contraAPINew({
    endpoint: "/api/v1/portfolio/holdings/auctions",
    method: "GET",
    params: {
      client_id: payload.client_id
    },
  });
}

function fetchFutureChain(payload) {
  return contraAPI({
    endpoint: `/api/v1/futureschain/NFO`,
    method: "GET",
    params: payload,
  });
}

function getEdisCaptcha() {
  return primusAPI({
    endpoint: `/api/v1/edis/create_captcha`,
    method: "POST",
    // data: payload,
  });
}

function boPinGeneration(payload) {
  return primusAPI({
    endpoint: `/api/v1/edis/bopin_generation`,
    method: "POST",
    data: payload,
  });
}

function generateTpin(payload) {
  return primusAPI({
    endpoint: `/api/v1/edis/tpin_generation`,
    method: "POST",
    data: payload,
  });
}

function changeTpin(payload) {
  return primusAPI({
    endpoint: `/api/v1/edis/change_tpin`,
    method: "POST",
    data: payload,
  });
}

function validateOtpPin(payload) {
  return primusAPI({
    endpoint: `/api/v1/edis/otp_tpin_validator`,
    method: "POST",
    data: payload,
  });
}

function freezeAccount() {
  return FreezeAPI({
    endpoint: "/api/v1/user/account/freeze",
    method: "POST",
  });
}

function setNewPassword(payload) {
  return primusAPI({
    endpoint: "/api/v4/user/password/set",
    method: "POST",
    data: payload,
  });
}


function fetchHistoricalTrades(payload) {
  return primusAPI({
    endpoint: `/api/v1/historical-trades/download`,
    method: "GET",
    params: {
      start_business_date: payload.startDate,
      end_business_date: payload.endDate,
      info: payload.info,
      exchange: payload.exchange,
      client_id: localStorage.getItem("login_id")
    }
  });
}

function downloadHistoricalTrades(payload) {
  return primusAPI({
    endpoint: `/api/v1/historical-trades/download`,
    method: "GET",
    params: {
      start_business_date: payload.startDate,
      end_business_date: payload.endDate,
      info: payload.info,
      exchange: payload.exchange,
      client_id: localStorage.getItem("login_id")
    }
  });
}

// Add this new function to fetch the trade history list with pagination
function fetchHistoricalTradesList(params) {
  return primusAPI({
    endpoint: "/api/v1/historical-trades",
    method: "GET",
    params: {
      page: params.page || 1,
      page_size: params.pageSize || 50,
      fetch_all: params.fetchAll || "ALL",
      client_ids: params.clientIds || localStorage.getItem("login_id"),
      buy_sell: params.buySell,
      exchange: params.exchange,
      is_error_trade: params.isErrorTrade,
      business_date: params.businessDate,
      start_business_date: params.businessDate,
      // end_business_date: params.businessDate
    }
  });
}

function fetchPnlHistory(payload) {
  return primusAPI({
    endpoint: "/api/v1/pnl-history",
    method: "GET",
    params: payload,
  });
}
function downloadPnlHistory(payload) {
  return primusAPI({
    endpoint: "/api/v1/pnl-history",
    method: "GET",
    params: payload,
  });
}

function fetchLedger(payload) {
  return primusAPI({
    endpoint: "/api/v1/ledger/advanced",
    method: "GET",
    params: {
      client_id: localStorage.getItem("login_id"),
      start_date: payload.start_date,
      end_date: payload.end_date,
      page: payload.page,
      page_size: payload.page_size,
      ledger_type: payload.ledger_type
    },
  });
}

function fetchBillDetail(payload) {
  return primusAPI({
    endpoint: "/api/v1/bills/advanced",
    method: "GET",
    params: {
      client_id: localStorage.getItem("login_id"),
      start_date: payload.start_date,
      end_date: payload.end_date,
      page: payload.page,
      page_size: payload.page_size,
      ledger_type: "BILL",
      bill_id: payload.bill_id
    },
  });
}

function fetchBillDetailPnl(payload) {
  return primusAPI({
    endpoint: "/api/v1/bills/advanced",
    method: "GET",
    params: {
      client_id: localStorage.getItem("login_id"),
      start_date: payload.start_date,
      end_date: payload.end_date,
      page: payload.page,
      page_size: payload.page_size,
      // ledger_type: "BILL",
      exchange: payload.exchange,
      bill_id: payload.bill_id
    },
  });
}



export {
  login,
  twoFA,
  loginV3,
  twoFAV3,
  searchInstrument,
  fetchHoldings,
  fetchPositions,
  fetchScripInfo,
  fetchMarketWatches,
  addNewMarketwatch,
  fetchPendingOrders,
  fetchCompletedOrders,
  fetchTrades,
  fetchAlerts,
  deleteMarketWatchInstrument,
  fetchScreeners,
  addMarketWatchInstrument,
  fetchUserProfile,
  updateUserSettings,
  fetchUserSettings,
  saveExistingMarketwatch,
  feedback,
  logout,
  postAlertModal,
  modifyAlert,
  fetchFundsTypes,
  fetchFundsView,
  fetchFundsViewV2,
  placeRegularOrder,
  modifyRegularOrder,
  fetchChartData,
  deleteAlert,
  pausePlayAlert,
  deletePendingOrder,
  getPinnedInstruments,
  fetchAvailableTwofaOptions,
  fetchQuestionsforTwofa,
  updateTwofa,
  placeBracketOrder,
  placeBracketOrderTRADELAB,
  modifyBracketOrderTRADELAB,
  cancelBracketOrderTRADELAB,
  exitCoverOrderTRADELAB,
  placeCOOrder,
  placeCoverOrderTRADELAB,
  modifyCoverOrderTRADELAB,
  modifyBracketOrder,
  cancelBracketOrder,
  exitCoverOrder,
  placeSpreadOrder,
  modifySpreadOrder,
  cancelSpreadOrderTRADELAB,
  fetchOrderHistory,
  setPinnedInstruments,
  resetPassword,
  reset2FA,
  reset2FA_TR,
  getForgotPasswordTradelab,
  setForgotPasswordTradelab,
  setForgotPasswordTR,
  changePassword,
  convertPosition,
  fetchAutorizedApps,
  updateTPin,
  authoriseHoldings,
  unblockUser,
  tlUnblockUser,
  getPaymentLink,
  postAccountBackofficePayout,
  getAccountDetailsBackofficePayout,
  getCoOrderTriggerRange,
  pledgeInstruments,
  getAllIpo,
  findMissingDetails,
  updateMissingDetails,
  placeOrder,
  modifyOrder,
  cancelOrder,
  cancelAMOOrder,
  fetchOrder,
  fetchOptionChain,
  fetchFutureChain,
  payoutTransactions,
  GetFunds,
  fetchBucketDataS3,
  uploadProfilePictureS3,
  updateProfilePicturePrimus,
  fetchBasketOrderDetails,
  getSingleBasketId,
  updateBasketExecutionState,
  createBasketOrderDetails,
  addBasketInstrumentDetails,
  deleteBasketOrderDetails,
  removeBasketInstrumentDetails,
  executeBasket,
  renameBasketName,
  updateBasketInstrumentDetails,
  signUp,
  getLtp,
  fetchFinStmtBackofficeIntegrated,
  fetchDigitalContractBackofficeIntegrated,
  fetchAdminMessages,
  fetchMarginCalculatorV1,
  ePledgeHoldings,
  fetchTrasferStatusLink,
  placeGTTOrder,
  fetchGTTOrders,
  cancelGTTOrder,
  addFunds,
  modifyGTTOrder,
  revokeAuthorization,
  verifyCaptchaToken,
  fetchMarginCalculatorV2,
  placeSIPOrder,
  fetchSIPOrders,
  cancelSIPOrder,
  modifySIPOrder,
  FetchNotifyingActions,
  FetchUserPreferences,
  CreateUserPreference,
  UpdateUserPreference,
  setNewPasswordTR,
  fetchAllOfs,
  PlaceOfsOrder,
  ModifyOfsOrder,
  CancelOfsOrder,
  OfsOrdersByClient,
  pausePlaySIP,
  getSipNameWithBasketID,
  placeSIP,
  placeOCOOrder,
  modifyOCOOrder,
  cancelOCOOrder,
  userSignUp,
  verifyOTPtoUserLogin,
  getKYCDetails,
  KRAUserDetails,
  sendOTPToMobile,
  verifyMobileOTP,
  generateDigiLockerAccessToken,
  SavePersonalDetails,
  VerifyBankDetails,
  loginWithOTP,
  // loginWithOTPV3,
  verifyLoginOTP,
  fetchNominees,
  saveNominees,
  updateNomineeShares,
  deleteNominee,
  updateDigioStatus,
  getAllBanks,
  getBankDetailsByIFSC,
  getAllBranchesOfABank,
  getBankDetailsByBankNameAndBranch,
  getDigilockerEsignReqId,
  getSubscriptionPlans,
  updateSubscriptionPlans,
  getDigilockerAuthToken,
  getKYCDetailsEnums,
  updateEsignDownload,
  placeSingleSIPOrder,
  saveTradingPreference,
  getUserExperinceDetails,
  getBrokerMasters,
  saveNomineesV2,
  AuctionDetails,
  readKycAPI,
  uploadKycAPI,
  setupTOTP,
  chooseTOTP,
  forgotTOTP,
  updateUserAddress,
  getBrokerageData,
  getEdisCaptcha,
  boPinGeneration,
  generateTpin,
  changeTpin,
  validateOtpPin,
  // fetchTotalMargin,
  freezeAccount,
  setNewPassword,
  ForgotPasswordSentOTP,
  getBankAccountOtp,
  addBankAccount,
  withdrawFunds,
  fetchHistoricalTrades,
  downloadHistoricalTrades,
  fetchHistoricalTradesList,
  fetchPnlHistory,
  downloadPnlHistory,
  fetchLedger,
  fetchBillDetail,
  fetchBillDetailPnl
};
